// 🧿 طلسم محافظ فایل

// Types
import {
  IBubbleConfig,
  IDeltaConfig,
  IRemainingDayConfig,
  ISellOrBuyQueueConfig,
  ISearchParameters,
  IBaseHedgerPairTableReport,
  IBaseHedgerPairAddOrEdit,
  ICalculationTableReport,
  IVConfigSettingDto,
  IIVOptionSearchParams,
  IHedgerDuedateTableReport,
  IHedgerAccountDuedateTableReport,
  IExeConfigDto,
  IOrderbookPairResp,
  IOrderBookDepth,
  IOrderBookDetails,
  ITaskTableReport,
  ITaskSearchParam,
  IExecusionSearchParams,
  ChartData,
  ITriggerTableReport,
  IGetPreviewOfferResp,
  IOrderTableSearchParams,
  IOrderTableReport,
  ITradeTableSearchParams,
  ITradeTableReport,
  IIVPutSearchParams,
  IIVTablePutReport,
  IConversionConfigDto,
  IVChartData,
  IChartCommonSearchParam,
  IAutomaticTaskOperationResult,
  IMarketmakingTaskSearchParam,
  ITaskExcelResult,
  ITaskExcelPreview,
} from "src/Interfaces/automaticMarketMaking";
import { ErrorTableReport } from "src/Interfaces/orderInterfaces";
import { Report } from "src/Interfaces/TableInterfaces";
import { Packet } from "src/Interfaces/commonDtos";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import {
  IMarketmakingPredefinedProgram,
  IMarketmakingProgram,
  IMarketmakingSetProgramBody,
} from "../Interfaces/marketmaking";
// Utilities
import {
  getRequest,
  getTable,
  putRequest,
  postRequest,
  deleteRequest,
  patchRequest,
  postDownloadExcel,
} from "./requestTemplates";
import { AxiosRequestConfig } from "axios";

export const exportTaskEditExcel = (filters: IMarketmakingTaskSearchParam) =>
  postDownloadExcel("/v1/automaticMarketMaking/ExportTaskEditExcel", filters);

export const previewTaskEditExcel = (file: File) => {
  const body = new FormData();
  body.append("file", file);
  return postRequest<FormData, ITaskExcelPreview>(
    "/v1/automaticMarketMaking/PreviewTaskEditExcel", body,
  );
};

export const importTaskEditExcel = (file: File, confirmedRows: number[]) => {
  const body = new FormData();
  body.append("file", file);
  body.append("confirmed", "true");
  confirmedRows.forEach(row => body.append("confirmedRows", row.toString()));
  return postRequest<FormData, ITaskExcelResult>(
    "/v1/automaticMarketMaking/ImportTaskEditExcel", body,
  );
};

// --------------- تعریف پایه - هجر ------------------
/**
 * Automatic Market Making => Base Hedger Pair
 * جدول تعریف پایه - هجر بازرگانی
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getBaseHedgerPairTable = (
  searchParam: ISearchParameters,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IBaseHedgerPairTableReport>> =>
  getTable<ISearchParameters, IBaseHedgerPairTableReport>(
    "/v1/automaticMarketMaking/BaseHedgerPairTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

/**
 * Automatic Market Making => Base Hedger Pair
 * تعریف پایه - هجر مدال متغیرهای ضریب حباب
 *
 * @async
 * @version 1.4.0
 */
export const getBubbleConfig = (): Promise<IBubbleConfig> =>
  getRequest("/v1/automaticMarketMaking/GetBubbleConfig");

/**
 * Automatic Market Making => Base Hedger Pair
 *  تعریف پایه - هجر ثبت مدال متغیرهای ضریب حباب
 *
 * @param {IBubbleConfig} data
 * @async
 * @version 1.4.0
 */
export const setBubbleConfig = (
  config: IBubbleConfig
): Promise<Packet<boolean>> =>
  putRequest("/v1/automaticMarketMaking/SetBubbleConfig", config);

/**
 * Automatic Market Making => Base Hedger Pair
 * تعریف پایه - هجر مدال متغیرهای ضریب دلتا
 *
 * @async
 * @version 1.4.0
 */
export const getDeltaConfig = (): Promise<IDeltaConfig> =>
  getRequest("/v1/automaticMarketMaking/GetDeltaConfig");

/**
 * Automatic Market Making => Base Hedger Pair
 *  تعریف پایه - هجر ثبت مدال متغیرهای ضریب دلتا
 *
 * @param {IDeltaConfig} data
 * @async
 * @version 1.4.0
 */
export const setDeltaonfig = (config: IDeltaConfig): Promise<Packet<boolean>> =>
  putRequest("/v1/automaticMarketMaking/SetDeltaConfig", config);

/**
 * Automatic Market Making => Base Hedger Pair
 * تعریف پایه - هجر مدال متغیرهای ضریب روز تا سررسید
 *
 * @async
 * @version 1.4.0
 */
export const getRemainingDayConfig = (): Promise<IRemainingDayConfig> =>
  getRequest("/v1/automaticMarketMaking/GetRemainingDayConfig");

/**
 * Automatic Market Making => Base Hedger Pair
 *  تعریف پایه - هجر ثبت مدال متغیرهای ضریب روز تا رسید
 *
 * @param {IRemainingDayConfig} data
 * @async
 * @version 1.4.0
 */
export const setRemainingDayConfig = (
  config: IRemainingDayConfig
): Promise<Packet<boolean>> =>
  putRequest("/v1/automaticMarketMaking/SetRemainingDayConfig", config);

/**
 * Automatic Market Making => Base Hedger Pair
 * تعریف پایه - هجر مدال متغیرهای ضریب صف فروش
 *
 * @async
 * @version 1.4.0
 */
export const getSellQueueConfig = (): Promise<ISellOrBuyQueueConfig> =>
  getRequest("/v1/automaticMarketMaking/GetSellQueueConfig");

/**
 * Automatic Market Making => Base Hedger Pair
 *  تعریف پایه - هجر ثبت مدال متغیرهای ضریب صف فروش
 *
 * @param {ISellOrBuyQueueConfig} data
 * @async
 * @version 1.4.0
 */
export const setSellQueueConfig = (
  config: ISellOrBuyQueueConfig
): Promise<Packet<boolean>> =>
  putRequest("/v1/automaticMarketMaking/SetSellQueueConfig", config);

/**
 * Automatic Market Making => Base Hedger Pair
 * تعریف پایه - هجر مدال متغیرهای ضریب صف خرید
 *
 * @async
 * @version 1.4.0
 */
export const getBuyQueueConfig = (): Promise<ISellOrBuyQueueConfig> =>
  getRequest("/v1/automaticMarketMaking/GetBuyQueueConfig");

/**
 * Automatic Market Making => Base Hedger Pair
 *  تعریف پایه - هجر ثبت مدال متغیرهای ضریب صف حرید
 *
 * @param {ISellOrBuyQueueConfig} data
 * @async
 * @version 1.4.0
 */
export const setBuyQueueConfig = (
  config: ISellOrBuyQueueConfig
): Promise<Packet<boolean>> =>
  putRequest("/v1/automaticMarketMaking/SetBuyQueueConfig", config);

/**
 * Automatic Market Making => Base Hedger Pair
 * تعریف پایه - هجر سررسید های مرجع
 *
 * @param {string} insId
 * @async
 * @version 1.4.0
 */
export const getManualValuesDropdown = (
  insId: string
): Promise<DropdownItem[]> =>
  getRequest(`v1/optionGreeks/GetDueDates?insId=${insId}`);

/**
 * Automatic Market Making => Base Hedger Pair
 * تعریف پایه - هجر افزودن
 *
 * @async
 * @version 1.4.0
 */
export const addBaseHedgerPairTask = (
  dto: IBaseHedgerPairAddOrEdit
): Promise<Packet<boolean>> =>
  postRequest("/v1/automaticMarketMaking/AddBaseHedgerPair", dto);

/**
 * Automatic Market Making => Base Hedger Pair
 * تعریف پایه - هجر ویرایش
 * @param {IBaseHedgerPairAddOrEdit} dto
 * @async
 * @version 1.4.0
 */
export const editBaseHedgerPairTask = (
  dto: IBaseHedgerPairAddOrEdit
): Promise<Packet<boolean>> =>
  postRequest("/v1/automaticMarketMaking/EditBaseHedgerPair", dto);

/**
 * Automatic Market Making => Base Hedger Pair
 * تعریف پایه - هجر حذف
 * @param {number} id
 * @async
 * @version 1.4.0
 */
export const deleteBaseHedgerPairTask = (
  id: number
): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/automaticMarketMaking/DeleteBaseHedgerPair?Id=${id}`);

//------------------- محاسبات ----------------------

/**
 * Automatic Market Making => Calculation
 * جدول محاسبات
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getCalculationTable = (
  searchParam: ISearchParameters,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<ICalculationTableReport>> =>
  getTable<ISearchParameters, ICalculationTableReport>(
    "/v1/automaticMarketMaking/GetCalculationTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

//------------------- IV ذنجیره آپشن ----------------------
/**
 * Automatic Market Making => IV Option
 * ذنجیره آپشن IV تنظیمات
 *
 * @async
 * @version 1.4.0
 */
export const getIVConfig = (): Promise<IVConfigSettingDto> =>
  getRequest("/v1/automaticMarketMaking/GetIVConfig");

/**
 * Automatic Market Making => IV Option
 * ذنجیره آپشن IV تنظیمات
 *
 * @param {IVConfigSettingDto} data
 * @async
 * @version 1.4.0
 */
export const setIVConfig = (
  config: IVConfigSettingDto
): Promise<Packet<boolean>> =>
  putRequest("/v1/automaticMarketMaking/SetIVConfig", config);

/**
 * Automatic Market Making => IV Option
 *
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getHedgerDuedateTable = (
  searchParam: IIVOptionSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IHedgerDuedateTableReport>> =>
  getTable<IIVOptionSearchParams, IHedgerDuedateTableReport>(
    "/v1/automaticMarketMaking/HedgerDuedateTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

/**
 * Automatic Market Making => IV Option
 *
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getHedgerAccountDuedateTable = (
  searchParam: IIVOptionSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IHedgerAccountDuedateTableReport>> =>
  getTable<IIVOptionSearchParams, IHedgerAccountDuedateTableReport>(
    "/v1/automaticMarketMaking/HedgerAccountDuedateTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

/**
 * Automatic Market Making => IV Option
 *  لیست اکانت ها براساس نماد پایه انتخاب شده
 *
 * @param {string} instrumentId
 * @async
 * @version 1.4.0
 */
export const getbaseInstrumentAccounts = (
  instrumentId: string
): Promise<DropdownItem[]> =>
  getRequest(
    `/v1/automaticMarketMaking/GetbaseInstrumentAccounts?InstrumentId=${instrumentId}`
  );

/**
 * Automatic Market Making => IV Option
 * نمودار
 *
 * @param {IIVOptionSearchParams} searchParam
 * @async
 * @version 1.4.0
 */
export const getHedgerDuedateXYPlot = (
  searchParam: IIVOptionSearchParams
): Promise<ChartData> =>
  postRequest("/v1/automaticMarketMaking/HedgerDuedateXYPlot", {
    ...searchParam,
  });

/**
 * Automatic Market Making => IV Option
 * نمودار
 *
 * @param {IIVOptionSearchParams} searchParam
 * @async
 * @version 1.4.0
 */
export const getHedgerAccountDuedateXYPlot = (
  searchParam: IIVOptionSearchParams
): Promise<ChartData> =>
  postRequest("/v1/automaticMarketMaking/HedgerAccountDuedateXYPlot", {
    ...searchParam,
  });

//------------------- IV ذنجیره پوت -------------------------
/**
 * Automatic Market Making => IV Put
 * نمودار ٪ کانولوژن
 *
 * @param {string} tableId
 * @async
 * @version 1.4.0
 */
export const getProfitGraph = (tableId: string): Promise<IVChartData[]> =>
  getRequest(
    `/v1/automaticMarketMaking/GetConversionProfitGraph?tableId=${tableId}`
  );

/**
 * Automatic Market Making => IV Put
 * نمودار IV
 *
 * @param {string} tableId
 * @async
 * @version 1.4.0
 */
export const getIVGraph = (tableId: string): Promise<IVChartData[]> =>
  getRequest(
    `/v1/automaticMarketMaking/GetConversionIVGraph?tableId=${tableId}`
  );

/**
 * Automatic Market Making => IV put
 * جدول IV
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getIVPutTable = (
  searchParam: IIVPutSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IIVTablePutReport>> =>
  getTable<IIVPutSearchParams, IIVTablePutReport>(
    "/v1/AutomaticMarketMaking/GetConversionIVTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

/**
 * Automatic Market Making => IV put
 * تنظیمات IV پوت
 *
 * @async
 * @version 1.4.0
 */
export const getConversionConfig = (): Promise<IConversionConfigDto> =>
  getRequest("/v1/automaticMarketMaking/GetConversionConfig");

/**
 * Automatic Market Making => IV put
 * تنظیمات IV پوت
 *
 * @param {IVConfigSettingDto} data
 * @async
 * @version 1.4.0
 */
export const setConversionConfig = (
  config: IConversionConfigDto
): Promise<Packet<boolean>> =>
  putRequest("/v1/automaticMarketMaking/SetConversionConfig", config);

/**
 * Automatic Market Making => IV put
 *  معیار کانورژن
 *
 * @param {string} baseInsId
 * @async
 * @version 1.4.0
 */
export const getHedgerOptionInstruments = async (
  baseInsId: string
): Promise<Array<DropdownItem>> =>
  getRequest(
    `/v1/AutomaticMarketMaking/GetHedgerOptionInstruments?baseInsId=${baseInsId}`
  );

//------------------- اجرای بازارگردانی----------------------

/**
 * Automatic Market Making => Execution
 * نماد پایه در جدول بازارگردانی
 *
 * @async
 * @version 1.4.0
 */
export const getBaseInsIds = (): Promise<DropdownItem[]> =>
  getRequest("/v1/automaticMarketMaking/GetBaseInsIds");

/**
 * Automatic Market Making => Execution
 * تنظیمات اجرای بازارگردانی
 *
 * @async
 * @version 1.4.0
 */
export const getExeConfig = (): Promise<IExeConfigDto> =>
  getRequest("/v1/automaticMarketMaking/GetExeConfig");

/**
 * Automatic Market Making => Execution
 * تنظیمات اجرای بازارگردانی
 *
 * @param {IVConfigSettingDto} data
 * @async
 * @version 1.4.0
 */
export const setExeConfig = (config: IExeConfigDto): Promise<Packet<boolean>> =>
  putRequest("/v1/automaticMarketMaking/SetExeConfig", config);

/**
 * Automatic Market Making => Execution
 *  order book
 *
 * @param {taskId} string
 * @async
 * @version 1.4.0
 */
export const getOrderBook = (
  taskId: string,
  signal?: AbortSignal,
): Promise<IOrderbookPairResp> => {
  const urlSearchParam = new URLSearchParams();
  let urlStr = "/v1/automaticMarketMaking/GetOrderBook";
  if (taskId) {
    urlSearchParam.append("TaskId", taskId.toString());
    urlStr += "?" + urlSearchParam;
  }
  return getRequest(urlStr, { signal });
};

export const getOrderBookDepth = (taskId: string, signal?: AbortSignal): Promise<IOrderBookDepth> =>
  getRequest(`/v1/automaticMarketMaking/GetOrderBookDepth?TaskId=${encodeURIComponent(taskId)}`, { signal });

export const getOrderBookDetails = (taskId: string, signal?: AbortSignal): Promise<IOrderBookDetails> =>
  getRequest(`/v1/automaticMarketMaking/GetOrderBookDetails?TaskId=${encodeURIComponent(taskId)}`, { signal });

/**
 * Automatic Market Making => Execution
 * جدول اجرای بازارگردانی
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getTaskTable = (
  searchParam: ITaskSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<ITaskTableReport>> =>
  getTable<ITaskSearchParam, ITaskTableReport>(
    "/v1/AutomaticMarketMaking/GetTaskTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

/**
 * Automatic Market Making => Execution
 * افزودن بازارگردانی
 *
 * @param {IExecusionSearchParams} dto
 * @async
 * @version 1.4.0
 */
export const editExecusionTask = (
  dto: IExecusionSearchParams
): Promise<Packet<boolean>> =>
  postRequest("/v1/automaticMarketMaking/editTask", dto);

/**
 * Automatic Market Making => Execution
 * افزودن بازارگردانی
 *
 * @param {IExecusionSearchParams} dto
 * @async
 * @version 1.4.0
 */
export const addExecusionTask = (
  dto: IExecusionSearchParams
): Promise<Packet<boolean>> =>
  postRequest("/v1/automaticMarketMaking/AddTASK", dto);

/**
 * Automatic Market Making => Execution
 *  حذف برنامه
 *
 * @param {string} name
 * @async
 * @version 1.4.0
 */
export const deletePredefinedProgram = (
  name: string
): Promise<Packet<boolean>> =>
  deleteRequest(
    `/v1/automaticMarketMaking/DeletePreDefinedProgram?programName=${name}`
  );

/**
 * Automatic Market Making => Execution
 *  گرفتن لیست برنامه
 *
 * @async
 * @version 1.4.0
 */
export const getPredefinedPrograms = (): Promise<
  IMarketmakingPredefinedProgram[]
> => getRequest("/v1/automaticMarketMaking/GetPreDefinedPrograms");

/**
 * Automatic Market Making => Execution
 *  گرفتن لیست برنامه
 *
 * @param {number} taskId
 * @async
 * @version 1.4.0
 */
export const getProgram = (taskId: number): Promise<IMarketmakingProgram> =>
  getRequest(`/v1/automaticMarketMaking/getProgram?taskId=${taskId}`);

/**
 * Automatic Market Making => Execution
 * ثبت برنامه پیش فرض
 *
 * @param {IMarketmakingPredefinedProgram} body
 * @async
 * @version 1.4.0
 */
export const setPredefinedProgram = (
  body: IMarketmakingPredefinedProgram
): Promise<Packet<boolean>> =>
  postRequest("/v1/automaticMarketMaking/AddPreDefinedProgram", body);

/**
 * Automatic Market Making => Execution
 * ثبت برنامه
 *
 * @param {IMarketmakingPredefinedProgram} body
 * @async
 * @version 1.4.0
 */
export const setAutoMarketmakingProgram = (
  body: IMarketmakingSetProgramBody
): Promise<Packet<boolean>> =>
  putRequest("/v1/automaticMarketMaking/setProgram", body);

/**
 * Automatic Market Making => All
 * گرفتن نمادهای پایه
 *
 * @async
 * @version 1.4.0
 */
export const getDistinctBaseInstrument = async (): Promise<
  Array<DropdownItem>
> => getRequest("/v1/automaticMarketMaking/DistinctBaseInstrument");

/**
 * Automatic Market Making => Execution
 * حذف از جدول تسک
 * @param {number[]} ids
 * @async
 * @version 1.4.0
 */
export const deleteTasks = (ids: number[]): Promise<Packet<boolean>> =>
  deleteRequest("/v1/automaticMarketMaking/deleteTask", { ids });

/**
 * Automatic Market Making => Execution
 * جدول تریگر
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getTriggerTable = (
  searchParam: { taskId: number },
  offset: number | null,
  pageSize: number | null
): Promise<Report<ITriggerTableReport>> =>
  getTable<{ taskId: number }, ITriggerTableReport>(
    "/v1/automaticMarketMaking/triggerTable",
    searchParam,
    offset,
    pageSize
  );

/**
 * Automatic Market Making => Execution
 *  جدول ارسال مجدد
 *
 * @param {number} taskId
 * @async
 * @version 1.4.0
 */
export const getPreviewOffers = (
  taskId: number,
  play: boolean = true
): Promise<IGetPreviewOfferResp | null> =>
  getRequest(
    `/v1/automaticMarketMaking/getPreviewOffers?taskId=${taskId}&Play=${play}`
  );

/**
 * Automatic Market Making => Execution
 *
 * پاوز کردن جدول تسک
 * @param {number[]} ids
 * @async
 * @version 1.4.0
 */
export const pauseTasks = (
  ids: number[],
  overrideMinimumTriggerInterval = false
): Promise<Packet<boolean>> =>
  patchRequest(`/v1/automaticMarketMaking/pauseTask`, {
    ids,
    overrideMinimumTriggerInterval,
  });

/**
 * Automatic Market Making => Execution
 *
 * اجرای مجدد کردن جدول تسک
 * @param {number[]} ids
 * @async
 * @version 1.4.0
 */
export const resumeTasks = (
  ids: number[],
  overrideMinimumTriggerInterval = false
): Promise<IAutomaticTaskOperationResult> =>
  patchRequest(`/v1/automaticMarketMaking/playTask`, {
    ids,
    overrideMinimumTriggerInterval,
  });

/**
 * Automatic Market Making => Execution
 *
 * اجرای مجدد کردن جدول تسک
 * @param {number[]} ids
 * @async
 * @version 1.4.0
 */
export const resendTasks = (
  ids: number[],
  overrideMinimumTriggerInterval = false
): Promise<IAutomaticTaskOperationResult> =>
  postRequest(`/v1/automaticMarketMaking/resendTask`, {
    ids,
    overrideMinimumTriggerInterval,
  });

/**
 * Automatic Market Making => Execution
 *
 * لغو کردن سفارش
 * @param {number} id
 * @async
 * @version 1.4.0
 */
export const cancelOrder = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/automaticMarketMaking/cancel?OrderId=${id}`);

/**
 * Automatic Market Making => Execution
 * جدول سفارشات بازارگردانی
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getOrderTable = (
  searchParam: IOrderTableSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IOrderTableReport>> =>
  getTable<IOrderTableSearchParams, IOrderTableReport>(
    "/v1/automaticMarketMaking/OrderTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

/**
 * Automatic Market Making => Execution
 * جدول معاملات بازارگردانی
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getTradeTable = (
  searchParam: ITradeTableSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<ITradeTableReport>> =>
  getTable<ITradeTableSearchParams, ITradeTableReport>(
    "/v1/automaticMarketMaking/TradeTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

/**
 * Automatic Market Making => Execution
 * جدول خطا بازارگردانی
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getErrorsTable = (
  searchParam: ITradeTableSearchParams | null,
  offset: number | null,
  pageSize: number | null
): Promise<Report<ErrorTableReport>> =>
  getTable<ITradeTableSearchParams, ErrorTableReport>(
    "/v1/automaticMarketMaking/ErrorTable",
    searchParam,
    offset,
    pageSize
  );

/**
 * Automatic Market Making => Execution
 *  گرفتن نمادهای پایه تعریف تسک
 *
 * @async
 * @version 1.4.0
 */
export const getTaskOptionInstrument = async (): Promise<Array<DropdownItem>> =>
  getRequest("/v1/automaticMarketMaking/TaskOptionInstrumentsDropdown");

/**
 * Automatic Market Making => Execution
 *  گرفتن اکانت‌های پایه تعریف تسک
 *
 * @param {number} id
 * @async
 * @version 1.4.0
 */
export const getTaskAccounts = async (
  id: number
): Promise<Array<DropdownItem>> =>
  getRequest(
    `/v1/AutomaticMarketMaking/TaskAccountsDropdown?optionInstrumentId=${id}`
  );

/**
 * Automatic Market Making => Execution
 * نمودار IV
 *
 * @param {IChartCommonSearchParam} searchParam
 * @async
 * @version 1.4.0
 */
export const getLiveIVChart = (
  searchParam: IChartCommonSearchParam
): Promise<IVChartData> =>
  postRequest("/v1/automaticMarketMaking/LiveIVChart", {
    ...searchParam,
  });

/**
 * Automatic Market Making => Execution
 * نمودار net vol
 *
 * @param {IChartCommonSearchParam} searchParam
 * @async
 * @version 1.4.0
 */
export const getNetVolume2Chart = (
  searchParam: IChartCommonSearchParam
): Promise<IVChartData> =>
  postRequest("/v1/automaticMarketMaking/NetVolume2Chart", {
    ...searchParam,
  });

/**
 * Automatic Market Making => Execution
 * نمودار net vol 2
 *
 * @param {IChartCommonSearchParam} searchParam
 * @async
 * @version 1.4.0
 */
export const getNetVolumeChart = (
  searchParam: IChartCommonSearchParam
): Promise<IVChartData> =>
  postRequest("/v1/automaticMarketMaking/NetVolumeChart", {
    ...searchParam,
  });

/**
 * Automatic Market Making => Execution
 * نمودار Open Interest
 *
 * @param {IChartCommonSearchParam} searchParam
 * @async
 * @version 1.4.0
 */
export const getOpenInterestChart = (
  searchParam: IChartCommonSearchParam
): Promise<IVChartData> =>
  postRequest("/v1/AutomaticMarketMaking/OpenInterestChart", {
    ...searchParam,
  });
